export default __webpack_public_path__ + "static/media/Owlington.bb5589cf.png";